// Use window.$ directly to avoid timing issues with jQuery loading
var $ = window.$ || window.jQuery;

$(document).on('keypress', 'input#job_client_name', function() {
  var e = $(this);
  console.log(e.val());
  
  $.get(
    '/clients/find_clients', 
    { client_name: e.val() }
  ).done(function(data) {
    client_list(data)
  });
});

$(document).on('change', '.job-status-list-menu', function() {
  window.location.href = '/jobs/?status=' + $(this).val();
});


$(document).on('click', '.client-list a', function() {
  $('#job_client_id').val( $(this).data('client-id') );
  $('#job_client_name').val( $(this).data('client-name') );
  $('.client-list li').remove();
  $('.client-list').hide();
}); 


$(document).on('change', '.list .status-menu select', function() {
  var status_id = $(this).val();
  var work_id = $(this).parents('li').data('work-id');
  var work_number = $(this).parents('li').data('work-number');
  var section = $('#main-body h2').data('section');
  var status_url = '/' + section + '/';
  var section_id = section.replace(/s$/, '') + '[id]';
  var section_status_id = section.replace(/s$/, '') + '[status_id]';
  
  console.log('==== status_id: ' + status_id);
  console.log('==== work_id: ' + work_id);
  console.log('==== work_number: ' + work_number);
  
  var data = { [section_id]: work_id, [section_status_id]: status_id };
  $.ajax({
    url: status_url + work_id, 
    type: 'PATCH',
    data: data
  });
  
  grab_job_counts();
});


$(document).on('change', '.done-checkbox', function() {
  var todo_id = $(this).data('id');
  var status_url = '/todos/' + todo_id;
  var data = { todo: { done: $(this).is(':checked') } }
  
  $.ajax({
    url: status_url, 
    type: 'PATCH',
    data: data
  })
});


$(document).on('turbo:load', function() {
  // https://github.com/amsul/pickadate.js
  /* $('.date-picker').pickadate({
    format: 'mm/dd/yyyy'
  });
  */

  // replacement for pickadate
  flatpickr('.date-picker', {
    dateFormat: 'm/d/Y', 
  });
  
  $('#client_name_label span').on('click', function() {
    var client_name_selected = $('#job_client_id option:selected').text();
    var $client_name = $('<input>');
    $('#client_name_label').append($client_name);
    $client_name.val( client_name_selected ).select();
    
    document.execCommand("copy");
    $client_name.remove();
  });
  
  $('.jobs-list li i.info-circle').mouseenter(function() {
    var row = $(this).parents('li');
    var work_id = $(row).data('work-id');
    
    $.get('/jobs/' + work_id + '/description_preview', function( data ) {
      $(row).append('<div class="preview"></div>');
      $('.preview').html(data);
    });
  });
  
  $('.jobs-list li i.info-circle').mouseleave(function() {
    $('.preview').remove();
  });
  
  //$('.trumbowyg-textarea').append($('.trumbowyg-textarea').val());
  
  $('.print-button').on('click', function() {
    $('.app-body').printThis();
  });
});


function client_list(data) {
  var clients = JSON.parse(data);
  
  $('.client-list').show()
  $('.client-list ul li').remove();
  
  clients.forEach(function(e) {
    $('.client-list ul').append('<li><a href="#" data-client-id="' + e[1] + '" data-client-name="' + e[0] + '">' + e[0] + '</a></li>');
  });  
}

function initFolderForm() {
  $('#job-folder-form form, #project-folder-form form').off('submit').on('submit', function() {
    $(this).find('input[type="submit"]').prop('disabled', true).val('Please wait...');
  });
}

// Expose globally
window.initFolderForm = initFolderForm;

// Initialize on document ready and Turbo events
$(document).on('turbo:load', initFolderForm);


